let debugging = getDebug()

if (document.querySelector("html.no-js")) {
    var elem = document.querySelector("html.no-js")
    elem.classList.remove("no-js")
    // if(debugging) {
    //     console.debug("DEBUG = true")
    // }
}

/**
 * debug helper function (simply a console.debug)
 * @param {String} text1 - first text to print
 * @param {*} Element - element / object or something else to debug in console
 * @param {String} text2 - optional: second text to print
 * @returns false, if debugging is 0
 */
export function dbg(text1, Element, text2) {
    if (debugging) {
        if (text2 != "" && text2 != undefined) {
            console.debug(text1, Element, text2)
        } else {
            console.debug(text1, Element)
        }
    } else return false
}

/**
 * helper function to find elements via querySelector
 * @param {*} elem className or ID of element to search for
 * @returns false, if no elements were found - else the found elem
 */
export function find(elem) {
    return document.querySelector(elem) ? document.querySelector(elem) : false
}

/**
 * helper function to find multiple elements via querySelector
 * @param {String} elem className or ID of element to search for
 * @returns false, if no elements were found - else the found elem
 */
export function findAll(elem) {
    return document.querySelectorAll(elem) ? document.querySelectorAll(elem) : false
}

/**
 * returns the deviceType - like "TABLE" "MOBILE" or "DESKTOP"
 * @returns {String} deviceType
 */
export function getDeviceType() {
    let ua = navigator.userAgent
    if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        // dbg("deviceType: ", "TABLET");
        return "tablet"
    }
    if (
        /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)
    ) {
        // dbg("deviceType: ", "MOBILE");
        return "mobile"
    }
    // dbg("deviceType: ", "DESKTOP");
    return "desktop"
}

/**
 *
 * @param {*} obj
 * @param {*} stack
 * @returns
 */
export function decycle(obj, stack = []) {
    if (!obj || typeof obj !== "object") return obj

    if (stack.includes(obj)) return null

    let s = stack.concat([obj])

    return Array.isArray(obj)
        ? obj.map((x) => decycle(x, s))
        : Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, decycle(v, s)]))
}

export function getDebug() {
    let debug = 0
    if (window.location.host == "typo3.2024.zts-betriebe.de.ddev.site") {
        debug = 1
    }
    return debug
}
